import { cn } from "@/lib/utils";
import { RxStarFilled } from "react-icons/rx";
import { useStrings } from "@/lib/i18n/context";

type StarRatingsProps = {
  className?: string;
  textColor?: string;
};

export const StarRatings = ({ className, textColor }: StarRatingsProps) => {
  const s = useStrings();
  return (
  <div className="flex justify-center">
    <div
      className={cn(
        "relative flex items-center gap-x-2 rounded-full bg-[#F5F6FB] px-2 py-1.5 text-[17px] text-gray-600",
        className,
      )}
    >
      <div className="flex items-center justify-center">
        {Array(5)
          .fill(null)
          .map((_, index) => (
            <RxStarFilled key={index} className="size-4 text-[#eab308]" />
          ))}
      </div>
      <span className={cn("select-none text-sm font-normal text-[#0A0D14]", textColor)}>
        <span className="font-medium">3.5M+</span>
        <span className="font-medium md:hidden">{s.hero.users}</span>
        <span className="hidden md:inline">{s.hero.usersWorldwide}</span>
      </span>
    </div>
  </div>
  );
};
